import React, { useEffect, useState } from "react";
import { Controller, useForm, useWatch } from "react-hook-form";
import Dropdown from "./commons/Dropdown";
import { arrCountry } from "../service";
import { saveShippingAddress } from "../redux/Actions/CartActions";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { FaSpinner } from "react-icons/fa6";

// const GHN_TOKEN = "31a64742-5e13-11f0-90c0-72fa78440389";
// const GHN_BASE_URL = "https://online-gateway.ghn.vn/shiip/public-api";


const API_PROVINCE = "https://esgoo.net/api-tinhthanh-new/1/0.htm";      // Lấy tất cả tỉnh
const API_WARD = "https://esgoo.net/api-tinhthanh-new/2";

const FormCheckout = ({ history, getData, onSubmit }) => {
    const dispatch = useDispatch();
    const {
        register,
        handleSubmit,
        control,
        watch,
        formState: { errors },
    } = useForm({
        defaultValues: {
            phone: "",
            fullname: "",

            address: "",
            apartment: "",
            // country: "Vietnam",
            city: "",
            state: "",
            ward: "",
            // zip: "",
            cardNumber: "",
            expDate: "",
            cvc: "",
            cardName: "",
            saveInfo: false,
            billingSame: true,
            paymentMethod: 'cod'
        },
    });
    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;
    // const onSubmit = (data) => {
    //     console.log("Checkout Data:", data);
    //     alert("Thanh toán thành công (fake)!");
    // };
    const cart = useSelector((state) => state.cart);
    const { cartItems } = cart;

    const total = cartItems.reduce((a, i) => a + i.qty * i.price, 0).toFixed(2);

    const { shippingAddress } = cart;

    const [provinces, setProvinces] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [wards, setWards] = useState([]);
    console.log(wards);

    const [provinceId, setProvinceId] = useState(shippingAddress?.saveData?.provinceId || "");
    const [districtId, setDistrictId] = useState(shippingAddress?.saveData?.districtId || "");
    const [wardCode, setWardCode] = useState(shippingAddress?.saveData?.wardCode || "");
    const [address, setAddress] = useState(shippingAddress?.saveData?.address || "");
    const [phone, setPhone] = useState(shippingAddress?.saveData?.phone || "");

    const [loadingProvinces, setLoadingProvinces] = useState(false);
    const [loadingDistricts, setLoadingDistricts] = useState(false);
    const [loadingWards, setLoadingWards] = useState(false);

    const orderCreate = useSelector((state) => state.orderCreate);

    const { loading } = orderCreate;
    // Load provinces

    // ✅ Lấy danh sách tỉnh từ API mới
    useEffect(() => {
        setLoadingProvinces(true);
        axios.get(API_PROVINCE)
            .then(res => {
                setProvinces(res.data?.data || []);
            })
            .catch(console.error)
            .finally(() => setLoadingProvinces(false));
    }, []);

    // ✅ Lấy danh sách Quận/Huyện/Phường theo tỉnh (API mới trả về tất cả phường/xã trong tỉnh)
    const getDistricts = async (province) => {
        console.log(province);

        if (!province) return;
        setLoadingDistricts(true);
        setLoadingWards(true);
        setDistricts([]);
        setWards([]);
        try {
            const res = await axios.get(`${API_WARD}/${province}.htm`);
            const data = res.data?.data || [];

            // Với API này không có "district", bạn phải tự nhóm theo tên Quận/Huyện nếu muốn.
            // Tạm thời gộp chung tất cả vào wards
            setWards(data); // data chứa danh sách Xã/Phường
        } catch (err) {
            console.error(err);
        } finally {
            setLoadingDistricts(false);
            setLoadingWards(false);
        }
    };

    // useEffect(() => {
    //     setLoadingProvinces(true);
    //     axios.get(`${GHN_BASE_URL}/master-data/province`, { headers: { token: GHN_TOKEN } })
    //         .then(res => setProvinces(res.data.data || []))
    //         .catch(console.error)
    //         .finally(() => setLoadingProvinces(false));
    // }, []);
    // const getDistricts = (provinceId) => {
    //     if (provinceId) {
    //         setDistrictId("");
    //         setWards([]);
    //         setWardCode("");
    //         setLoadingDistricts(true);
    //         axios.post(`${GHN_BASE_URL}/master-data/district`,
    //             { province_id: parseInt(provinceId) },
    //             { headers: { token: GHN_TOKEN } }
    //         )
    //             .then(res => setDistricts(res.data.data || []))
    //             .catch(console.error)
    //             .finally(() => setLoadingDistricts(false));
    //     } else {
    //         setDistricts([]);
    //     }
    // }

    // const getWards = (districtId) => {
    //     if (districtId) {

    //         setWardCode("");
    //         setLoadingWards(true);
    //         axios.post(`${GHN_BASE_URL}/master-data/ward`,
    //             { district_id: parseInt(districtId) },
    //             { headers: { token: GHN_TOKEN } }
    //         )
    //             .then(res => {
    //                 setWards(res.data.data || [])
    //             })
    //             .catch(console.error)
    //             .finally(() => setLoadingWards(false));
    //     } else {
    //         setWards([]);
    //     }
    // }
    const values = useWatch({ control });
    useEffect(() => {
        if (values) {
            console.log("Form auto submit: ", values);
            const { address, phone, lastName, firstName, city, state, ward, country, saveInfo, paymentMethod } = values;
            // if (phone && !/^\d{8,12}$/.test(phone)) {
            //     alert("Số điện thoại không hợp lệ (8-12 chữ số)");
            //     return;
            // }
            const fullAddress = `${address}, ${ward.label}, ${state.label}`;
            getData({
                address: fullAddress,
                city: phone,
                postalCode: `(${state.value},${ward.value})`,
                country: 'VN',
                paymentMethod: paymentMethod,
                saveData: { provinceId: state.value, wardCode: ward.value, address, phone }
            }); // truyền về cha
            dispatch(saveShippingAddress({
                address: fullAddress,
                city: phone,
                postalCode: `(${state.value},${ward.value})`,
                country: 'VN',
                paymentMethod: paymentMethod,
                saveData: { provinceId: state.value, wardCode: ward.value, address, phone }
            }));
        }
    }, [values, getData]);
    const onSubmit_ = (values) => {


        console.log("valuesvalues ", values);

        const { address, phone, lastName, firstName, city, state, ward, country, paymentMethod } = values;
        if (!/^\d{8,12}$/.test(phone)) {
            alert("Số điện thoại không hợp lệ (8-12 chữ số)");
            return;
        }
        onSubmit();
    };
    return (
        <form
            id="checkoutForm"
            onSubmit={handleSubmit(onSubmit_)}
            className="col-span-1 space-y-6 bg-white p-6"
        >
            {/* Contact */}
            <div>
                <h2 className="text-lg font-semibold mb-2">Liên hệ</h2>
                <input
                    type="text"
                    placeholder="Số điện thoại"
                    {...register("phone", { required: "Vui lòng nhập số điện thoại" })}
                    className="w-full border p-2 rounded mb-2"
                />
                {errors.phone && (
                    <p className="text-red-500 text-sm">{errors.phone.message}</p>
                )}

                <label className="flex items-center gap-2 text-sm">
                    <input type="checkbox" {...register("saveInfo")} />
                    Gửi email cho tôi với tin tức và ưu đãi

                </label>
            </div>

            {/* Delivery */}
            <div>
                <h2 className="text-lg font-semibold mb-2">Vận chuyển</h2>

                <div className="grid ">
                    <input
                        type="text"
                        placeholder="Họ tên"
                        {...register("fullname", { required: "Họ tên là bắt buộc" })}
                        className="border w-full p-2 rounded text-sm"
                    />
                </div>
                <input
                    type="text"
                    placeholder="Địa chỉ"
                    {...register("address", { required: "Địa chỉ là bắt buộc" })}
                    className="w-full border p-2 rounded my-2 text-sm"
                />
                {/* <input
                    type="text"
                    placeholder="Căn hộ, phòng suite, v.v. (tùy chọn)"
                    {...register("apartment")}
                    className="w-full border p-2 rounded mb-2 text-sm"
                /> */}
                <div className="grid grid-cols-3 gap-2">
                    <div className="">
                        <Controller
                            name="state"
                            control={control}

                            rules={{ required: "Vui lòng chọn Tỉnh/Thành" }}
                            render={({ field }) => (
                                <Dropdown
                                    loading={loadingProvinces}
                                    // items={(provinces || [])?.map((value) => { return { label: value.ProvinceName, value: value.ProvinceID } })}
                                    items={(provinces || [])?.map((p) => ({
                                        label: p.name,
                                        value: p.id
                                    }))}
                                    placeholder="Tỉnh/Thành"
                                    className="!w-full border rounded-md h-full"
                                    // field.onChange để cập nhật giá trị vào react-hook-form
                                    onSelect={(value) => {
                                        field.onChange(value);        // cập nhật cho react-hook-form
                                        getDistricts(value.value);         // gọi thêm logic của bạn
                                        // setTimeout(() => {
                                        //     handleSubmit(onSubmit)();
                                        // }, 500);
                                        console.log("Selected province:", value);
                                    }}
                                    // field.value để hiển thị giá trị hiện tại
                                    value={field.value}
                                />
                            )}
                        />
                        {errors.state && (
                            <p className="text-red-500 text-sm">{errors.state.message}</p>
                        )}
                    </div>
                    {/* <div className="">
                        <Controller
                            name="city"
                            control={control}
                            rules={{ required: "Vui lòng chọn Quận/Huyện" }}

                            render={({ field }) => (
                                <Dropdown
                                    loading={loadingDistricts}
                                    items={(districts || [])?.map((value) => { return { label: value.DistrictName, value: value.DistrictID } })}
                                    placeholder="Quận/Huyện"
                                    className="!w-full border rounded-md  h-full"
                                    onSelect={(value) => {
                                        field.onChange(value);        // cập nhật cho react-hook-form
                                        getWards(value.value);         // gọi thêm logic của bạn
                                        // handleSubmit(onSubmit)();
                                        console.log("Selected province:", value);
                                    }}
                                    value={field.value}

                                />
                            )}
                        />
                        {errors.city && (
                            <p className="text-red-500 text-sm">{errors.city.message}</p>
                        )}
                    </div> */}
                    <div>
                        <Controller
                            name="ward"
                            control={control}
                            rules={{ required: "Vui lòng chọn Phường/Xã" }}

                            render={({ field }) => (
                                <Dropdown
                                    loading={loadingWards}
                                    // items={(wards || [])?.map((value) => { return { label: value.WardName, value: value.WardCode } })}
                                    items={(wards || [])?.map((w) => ({
                                        label: w.name,
                                        value: w.code
                                    }))}
                                    placeholder="Phường/Xã"
                                    className="!w-full border rounded-md  h-full"
                                    onSelect={(value) => {
                                        field.onChange(value);        // cập nhật cho react-hook-form
                                        setWardCode(value.value);         // gọi thêm logic của bạn
                                        // handleSubmit(onSubmit)();
                                        console.log("Selected province:", value);
                                    }}
                                    value={field.value}

                                />
                            )}
                        />
                        {errors.city && (
                            <p className="text-red-500 text-sm">{errors.city.message}</p>
                        )}
                    </div>
                </div>
                {/* <label className="flex items-center gap-2 text-sm mt-2">
                    <input type="checkbox" {...register("saveInfo")} />
                    Lưu thông tin này cho lần sau
                </label> */}
                <p style={{color: '#e70000', fontSize: 14, marginTop: 10}}>Chú ý: Đối với các đơn hàng ngoại thành hoặc tỉnh khác, phí vận chuyển sẽ không được tính vào hóa đơn. Khách hàng sẽ thanh toán phí ship trực tiếp cho đơn vị vận chuyển khi nhận hàng.</p>
            </div>

            {/* Shipping */}
            {/* <div>
                <h2 className="text-lg font-semibold mb-2">Phương thức vận chuyển</h2>
                <p className="text-sm text-gray-600 border p-2 rounded">
                    Nhập địa chỉ giao hàng của bạn để xem các phương thức giao hàng có sẵn.
                </p>
            </div> */}

            {/* Payment */}
            <div>
                <h2 className="text-lg font-semibold mb-2">Thanh toán</h2>
                <p className="text-sm text-gray-500 mb-2">
                    Mọi giao dịch đều an toàn và được mã hóa.
                </p>
                {
                    userInfo ?
                        <label className="flex items-center gap-2 text-sm">
                            <input name="paymentMethod" value={'point'} type="radio" {...register("paymentMethod")}

                            />
                            Thanh toán bằng <img src="/images/logoToken.png" style={{ width: 20 }} />

                        </label>
                        :
                        null
                }
                <label className="flex items-center gap-2 text-sm">
                    <input name="paymentMethod" value={'cod'} type="radio" {...register("paymentMethod")}
                    />
                    Thanh toán khi nhận hàng

                </label>
                <label className="flex items-center gap-2 text-sm">
                    <input name="paymentMethod" value={'now'} type="radio" {...register("paymentMethod")}
                    />
                    Thanh toán ngay
                </label>
            </div>

            <button
                type="submit"
                className={`hidden md:flex items-center justify-center gap-2  w-full bg-blue-600 text-white py-3 rounded font-semibold hover:bg-blue-700 ${loading ? "opacity-60" : ""}`}
                disabled={loading}
            >
                ĐẶT HÀNG {loading && <FaSpinner className="animate-spin text-white" />}
            </button>
        </form >
    );
};

export default FormCheckout;
